import { getVueTemplate } from "../../_imports/utils/utils.common";
import BaseFormComponent from "../_imports/base-form-component.vue";

export default {
	name: 'forms-error-message',
	template: getVueTemplate('forms-error-message'),
	mixins: [
		BaseFormComponent
	],
	props: {
		error: Object
	},
	data() {
		return {
			isVisible: false
		}
	},
	watch: {
		formState() {
			this.isVisible = this.formState.formSubmitError;
		}
	}
};